import $ from 'jquery';
import WorkPage from '../work/WorkPage';
import TyreHandlebarsHelpers from './TyreHandlebarsHelpers';
import TyreStateManager from './TyreStateManager';
import TyreApiClient from './TyreApiClient';
import TyreRenderer from './TyreRenderer';
import TyreBusinessLogic from './TyreBusinessLogic';

export default class TyrePageController {
  constructor(workPage) {
    this.workPage = workPage || new WorkPage();
    this.stateManager = new TyreStateManager();
    this.apiClient = new TyreApiClient(this.workPage.quoteService);
    this.renderer = new TyreRenderer(this.stateManager, this.apiClient, {
      quantitySelectSelector: '.js-tyres-quantity-select',
      specSelectSelector: '.js-tyres-spec-select',
      tyreSelectSelector: '.js-tyres-tyre-select',
    });
    this.businessLogic = new TyreBusinessLogic(this.workPage, this.stateManager, this.apiClient, this.renderer);
    this.tyresPage = $('.tyres-page');
    this.quantitySelectSelector = '.js-tyres-quantity-select';
    this.specSelectSelector = '.js-tyres-spec-select';
    this.specBackSelector = '.js-tyres-spec-back';
    this.tyreBackSelector = '.js-tyres-tyre-back';
    this.tyreSelectSelector = '.js-tyres-tyre-select';
    this.sameAsFrontSelector = '#same-as-front';
    this.tyresRefineContainerSelector = '.tyres-refine-container';
    this.tyresRefineSelector = '.js-tyres-tyre-refine';
    this.tyresRefineCloseSelector = '.tyres-refine-close';
  }

  init() {
    TyreHandlebarsHelpers.register();
    this._initializePage();
    this._bindEvents();
  }

  _initializePage() {
    if (this.tyresPage.length) {
      this.apiClient.fetchTyreSummary((summary) => {
        const selections = this.stateManager.getSelections();
        if (summary.front || summary.rear) {
          this.stateManager.setSelections(summary);
          this.apiClient.fetchTyres(this.stateManager.getSelections(), (tyres, metaData) => this.businessLogic.refineAndRenderTyres(tyres, metaData));
          return;
        }
        this.renderer.renderQuantitySelect(this.tyresPage, this.stateManager.getSelections());
      });
    }
  }

  _bindEvents() {
    this._bindItemRemovedEvent();
    this._bindQuantityEvents();
    this._bindSpecEvents();
    this._bindTyreEvents();
    this._bindRefineEvents();
  }

  _bindItemRemovedEvent() {
    this.tyresPage.on('item_removed', () => {
      this.stateManager.getSelections().clearTyreSelections();
      this.tyresPage.find('.tyres-basket').empty();
      $('.js-tyres-tyre-select.added').trigger('tyreRemoved');
    });
  }

  _bindQuantityEvents() {
    this.tyresPage.on('checked', '.js-tyres-quantity-select', (event) => {
      const $this = $(event.currentTarget);
      const position = $this.data('position');
      const selections = this.stateManager.getSelections();
      const quantity = $this.val();
      selections.quantity(position, quantity);
      $(this.quantitySelectSelector).prop('disabled', false);
    });

    this.tyresPage.on('unchecked', '.js-tyres-quantity-select', (event) => {
      const $this = $(event.currentTarget);
      const position = $this.data('position');
      const selections = this.stateManager.getSelections();
      selections.removeQuantity(position);
      if (!selections.hasQuantity()) $(this.quantitySelectSelector).prop('disabled', true);
    });

    this.tyresPage.on('click', this.quantitySelectSelector, () => {
      const selections = this.stateManager.getSelections();

      _kmq.push([
        'record',
        'Selected Tyre Quantity',
        {
          ...selections.quantities(),
        },
      ]);

      this.renderer.renderSpecSelect(this.tyresPage, selections);
    });
  }

  _bindSpecEvents() {
    this.tyresPage.on('click', this.specBackSelector, () => {
      this.renderer.renderQuantitySelect(this.tyresPage, this.stateManager.getSelections());
    });

    this.tyresPage.on('click', this.specSelectSelector, () => {
      const selections = this.stateManager.getSelections();
      const positions = selections.symmetric() ? ['front'] : selections.positions();

      _kmq.push([
        'record',
        'Selected Tyre Fitment',
        positions.reduce((properties, position) => {
          const positionKey = selections.symmetric() ? 'both' : position;
          properties[positionKey] = selections.specification(position).toString();
          return properties;
        }, {}),
      ]);

      if (selections.specificationHasChanged() || !selections.hasSelectedTyres()) this.workPage.removeJob(5000, true);
      this.apiClient.fetchTyres(selections, (tyres, metaData) => {
        this.businessLogic.refineAndRenderTyres(tyres, metaData);

        const properties = { ...metaData };
        Object.keys(properties).forEach((prop) => {
          if (properties[prop].count >= 0) properties[prop] = properties[prop].count;
        });
        _kmq.push(['record', 'Tyre Products Shown', properties]);
      });
    });

    this.tyresPage.on('click', this.sameAsFrontSelector, (event) => {
      const selections = this.stateManager.getSelections();
      if ($(event.currentTarget).is(':checked')) {
        selections.asymmetric(false);
        $('.tyres-spec-select-front .tyres-position').html('Front &amp; Rear');
        $('.tyres-spec-select-rear').hide();
        if (selections.isFullySpecified()) $(this.specSelectSelector).prop('disabled', false);
      } else {
        selections.asymmetric(true);
        const spinner = $($('.tyres-spec-rear .tyres-spec-select .loading-spinner')[0]);
        spinner.removeClass('hidden');
        this.apiClient.fetchTyreSpecs('rear', selections, true, (data) => {
          if (data['widths'] && (!selections.specification('rear').width || true))
            this.renderer.populateSpecSelectOptions('rear', 'width', data['widths'], selections);
          if (data['profiles'] && (!selections.specification('rear').profile || true))
            this.renderer.populateSpecSelectOptions('rear', 'profile', data['profiles'], selections);
          if (data['rims'] && (!selections.specification('rear').rim || true))
            this.renderer.populateSpecSelectOptions('rear', 'rim', data['rims'], this.stateManager.getSelections());
          if (data['speed_ratings'] && (!selections.specification('rear').speed || true))
            this.renderer.populateSpecSelectOptions('rear', 'speed', data['speed_ratings'], this.stateManager.getSelections());
          spinner.addClass('hidden');
        });
        $('.tyres-spec-select-front .tyres-position').html('Front');
        $('.tyres-spec-select-rear').show();
        if (!selections.isFullySpecified()) $(this.specSelectSelector).prop('disabled', true);
      }
    });

    this._bindSpecChangeEvents();

    this.tyresPage.on('click', this.tyreBackSelector, () => {
      this.renderer.renderSpecSelect(this.tyresPage, this.stateManager.getSelections());
    });
  }

  _bindSpecChangeEvents() {
    const keys = ['width', 'profile', 'rim', 'speed'];

    ['front', 'rear'].forEach((position) => {
      keys.forEach((key, i) => {
        this.tyresPage.on('change', '#tyres-spec-' + position + '-' + keys[i], (event) => {
          const $this = $(event.currentTarget);
          const selections = this.stateManager.getSelections();

          selections.specification(position).set(key, $this.val());
          selections.specificationHasChanged(true);

          const spinner = $($('.tyres-spec-' + position + ' .tyres-spec-select .loading-spinner')[i + 1]);
          spinner.removeClass('hidden');

          const caret = $($('.tyres-spec-' + position + ' .tyres-spec-select.select')[i + 1]);

          keys.forEach((key, j) => {
            if (j > i) {
              this.renderer.clearSpecSelectOptions(position, keys[j]);

              const select = $($('.tyres-spec-' + position + ' .tyres-spec-select.select select')[j]);
              select.prop('disabled', true);
              select.closest('.tyres-spec-select').addClass('select-hidden');
            }
          });
          this.apiClient.fetchTyreSpecs(position, selections, false, (data) => {
            if (data['widths'] && (!selections.specification(position).width || false))
              this.renderer.populateSpecSelectOptions(position, 'width', data['widths'], selections);
            if (data['profiles'] && (!selections.specification(position).profile || false))
              this.renderer.populateSpecSelectOptions(position, 'profile', data['profiles'], selections);
            if (data['rims'] && (!selections.specification(position).rim || false))
              this.renderer.populateSpecSelectOptions(position, 'rim', data['rims'], this.stateManager.getSelections());
            if (data['speed_ratings'] && (!selections.specification(position).speed || false))
              this.renderer.populateSpecSelectOptions(position, 'speed', data['speed_ratings'], this.stateManager.getSelections());
            spinner.addClass('hidden');
            caret.removeClass('select-hidden');
          });
          if (selections.isFullySpecified()) {
            $(this.specSelectSelector).prop('disabled', false);
          } else {
            $(this.specSelectSelector).prop('disabled', true);
          }
        });
      });
    });
  }

  _bindTyreEvents() {
    this.tyresPage.on('click', this.tyreSelectSelector, (event) => {
      const $this = $(event.currentTarget);
      const supplier_code = $this.data('tyre-supplier-code');
      const position = $this.data('tyre-position');

      if ($this.hasClass('added')) {
        this.businessLogic.removeTyre(position);
        $this.trigger('tyreRemoved');
      } else {
        this.businessLogic.addTyre(supplier_code, position, this.stateManager.getSelections());
        $this.trigger('tyreAdded');
      }
      this.renderer.renderTyresBasket(this.tyresPage.find('.tyres-basket'), this.stateManager.getTyres());
    });

    this.tyresPage
      .on('tyreAdded', this.tyreSelectSelector, (event) => {
        const $this = $(event.currentTarget);
        const position = $this.data('tyre-position');
        const supplierCode = $this.data('tyre-supplier-code');

        $this.addClass('added');
        if ($this.hasClass('tyres-add-button')) {
          $this.removeClass('button-blue').addClass('button-red');
          $this.text('Remove');
        }
        const selectedTyre = $(this.tyreSelectSelector + '[data-tyre-supplier-code="' + supplierCode + '"]');
        $(this.tyreSelectSelector + '[data-tyre-position="' + position + '"]')
          .not(selectedTyre)
          .prop('disabled', true);

        const selectedTyreContainer = selectedTyre.closest('.tyre-container');
        $('.tyre-container[data-tyre-position="' + position + '"]')
          .not(selectedTyreContainer)
          .addClass('grey-out');
      })
      .on('tyreRemoved', this.tyreSelectSelector, (event) => {
        const $this = $(event.currentTarget);
        const position = $this.data('tyre-position');

        const selectedTyre = $(this.tyreSelectSelector + '[data-tyre-position="' + position + '"]');
        selectedTyre.removeClass('added button-red').addClass('button-blue').prop('disabled', false);
        const quantity = $this.data('tyre-quantity');
        if (selectedTyre.hasClass('tyres-add-button')) {
          selectedTyre.text('Add ' + quantity);
        }
        $('.tyre-container[data-tyre-position="' + position + '"]').removeClass('grey-out');
      });
  }

  _bindRefineEvents() {
    this.tyresPage.on('click', this.tyresRefineSelector, () => {
      const selector = $(this.tyresRefineContainerSelector);
      this.renderer.renderTyreRefine(selector, () => this.businessLogic.applyRefinements());
      if (selector.is(':visible')) {
        selector.slideUp();
      } else {
        selector.slideDown();
      }
    });

    this.tyresPage.on('click', this.tyresRefineCloseSelector, () => {
      const selector = $(this.tyresRefineContainerSelector);
      selector.slideUp();
    });
  }
}
